<div class="flex items-center gap-2 justify-between p-2 px-5">
  <div class="flex items-center gap-2">
    <h2 class="text-lg font-bold" >Configuración de Viajes Pineados</h2>
    <mat-icon class="text-amber-500 rotate-45">push_pin</mat-icon>
  </div>
  <button mat-icon-button (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <!-- Información actual -->
  <mat-card class="mb-5">
    <mat-card-content>
      <div class="flex items-center gap-2 mb-3">
        <mat-icon color="primary">info</mat-icon>
        <strong>Estado Actual</strong>
      </div>

      <div class="flex justify-between mb-2">
        <span>Viajes pineados:</span>
        <strong [ngClass]="pinnedCount > 0 ? 'text-amber-500' : 'text-gray-600'">
          {{ pinnedCount }}
        </strong>
      </div>

      <div class="flex justify-between">
        <span>Modo actual:</span>
        <strong>{{ selectedMode === 'all' ? 'Todos los viajes' : 'Solo pineados' }}</strong>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-divider class="my-5"></mat-divider>

  <!-- Opciones de visualización -->
  <div class="mb-5">
    <div class="flex items-center gap-2 mb-4">
      <mat-icon>visibility</mat-icon>
      <strong>Modo de Visualización</strong>
    </div>

    <mat-radio-group
      [(ngModel)]="selectedMode"
      (change)="onModeChange($event.value)"
      class="flex flex-col gap-4">

      <mat-radio-button value="all">
        <div class="pl-2">
          <div class="flex items-center gap-2">
            <mat-icon class="text-lg">list</mat-icon>
            <strong>Mostrar todos los viajes</strong>
          </div>
          <div class="text-gray-600 text-sm mt-1 ml-7">
            Muestra todos los viajes con los pineados al inicio de la lista
          </div>
        </div>
      </mat-radio-button>

      <mat-radio-button value="pinned-only" [disabled]="!canSelectPinnedOnly()">
        <div class="pl-2">
          <div class="flex items-center gap-2">
            <mat-icon class="text-lg">filter_list</mat-icon>
            <strong>Solo viajes pineados</strong>
            <span *ngIf="pinnedCount > 0"
                  class="bg-amber-500 text-white px-2 py-0.5 rounded-full text-xs ml-2">
              {{ pinnedCount }}
            </span>
          </div>
          <div class="text-gray-600 text-sm mt-1 ml-7">
            Solo muestra los viajes que hayas marcado como pineados
          </div>
          <div *ngIf="!canSelectPinnedOnly()"
               class="flex items-center gap-1 text-amber-500 text-sm mt-1 ml-7">
            <mat-icon class="text-base">warning</mat-icon>
            <span>No hay viajes pineados</span>
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>

    <!-- Descripción del modo seleccionado -->
    <mat-card *ngIf="getModeDescription()" class="mt-4 bg-blue-50">
      <mat-card-content class="flex items-start gap-2 p-3">
        <mat-icon color="primary" class="text-xl">help_outline</mat-icon>
        <p class="m-0 text-blue-800 text-sm">{{ getModeDescription() }}</p>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-divider *ngIf="pinnedCount > 0" class="my-5"></mat-divider>

  <!-- Acciones adicionales -->
  <div *ngIf="pinnedCount > 0">
    <div class="flex items-center gap-2 mb-4">
      <mat-icon>settings</mat-icon>
      <strong>Acciones Adicionales</strong>
    </div>

    <mat-card class="bg-red-50 border border-red-200">
      <mat-card-content class="flex items-center justify-between gap-4 flex-wrap sm:flex-nowrap">
        <div class="flex items-center gap-3">
          <mat-icon class="text-amber-500">delete_sweep</mat-icon>
          <div>
            <div class="font-semibold">Limpiar todos los pines</div>
            <div class="text-sm text-gray-600">Esto despineará todos los viajes marcados</div>
          </div>
        </div>
        <button mat-stroked-button
                color="warn"
                [disabled]="isLoading"
                (click)="onClearAll()"
                class="w-full sm:w-auto">
          <mat-icon *ngIf="!isLoading">clear_all</mat-icon>
          <mat-icon *ngIf="isLoading" class="spinning">sync</mat-icon>
          {{ isLoading ? 'Limpiando...' : 'Limpiar Todo' }}
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isLoading">
    Cancelar
  </button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="isLoading">
    <mat-icon *ngIf="!isLoading">check</mat-icon>
    <mat-icon *ngIf="isLoading" class="spinning">sync</mat-icon>
    {{ isLoading ? 'Aplicando...' : 'Aplicar' }}
  </button>
</mat-dialog-actions>